import { combineReducers } from "redux";
import teachingMaterials from "./teachingMaterials/reducer";
export default combineReducers({
  teachingMaterials
});
